import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class AgentUserType {
  public readonly key = 'AgentUserType';
  public readonly enrollTrackRole = EnrollTrackRole.Agent;
}
